/**
 * Audio notification utility for incoming calls
 */

let audioInstance: HTMLAudioElement | null = null;

/**
 * Initializes the audio notification system
 * Audio playback disabled - visual notification only (no ringtone)
 */
export function initAudioNotification(): void {
  // Audio notification disabled - no ringtone will play
  // Only visual notification will be shown
  // No audio file is loaded
}

/**
 * Plays the call notification audio
 * Audio playback disabled - visual notification only (no ringtone)
 */
export function playCallNotification(): void {
  // Audio notification disabled - no ringtone will play
  // Only visual notification will be shown
  // Function kept for compatibility but does nothing
}

/**
 * Stops the call notification audio
 */
export function stopCallNotification(): void {
  if (audioInstance) {
    audioInstance.pause();
    audioInstance.currentTime = 0;
  }
  
  // Also try direct access
  if ((window as any).__callNotificationAudio) {
    const audio = (window as any).__callNotificationAudio;
    audio.pause();
    audio.currentTime = 0;
  }
  
  // Note: Removed event dispatch to prevent circular calls
  // Components should call stopCallNotification() directly or use window.stopCallNotification
}

/**
 * Cleans up audio resources
 */
export function cleanupAudioNotification(): void {
  if (audioInstance) {
    audioInstance.pause();
    audioInstance = null;
  }
  delete (window as any).__callNotificationAudio;
}
